import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const token = localStorage.getItem('token');
  
  // If no token, redirect to login page
  if (!token) {
    return <Navigate to="/" />;
  }

  // Otherwise, render the child components (the admin dashboard)
  return <Outlet />;
};

export default PrivateRoute;
